export var HubNames;
(function (HubNames) {
    /**
     * Office.com and Office Windows App
     */
    HubNames["office"] = "Office";
    /**
     * Microsoft-internal test Host
     */
    HubNames["orange"] = "Orange";
    /**
     * For "desktop" specifically, this refers to the new, pre-release version of Outlook for Windows.
     * Also used on other platforms that map to a single Outlook client.
     */
    HubNames["outlook"] = "Outlook";
    /**
     * Outlook for Windows: the classic, native, desktop client
     */
    HubNames["outlookWin32"] = "OutlookWin32";
    /**
     * Teams v1
     */
    HubNames["teams"] = "Teams";
    /**
     * Modern Teams
     */
    HubNames["teamsModern"] = "TeamsModern";
})(HubNames || (HubNames = {}));
export var PlatformType;
(function (PlatformType) {
    PlatformType["windows"] = "windows";
    PlatformType["macOs"] = "macos";
})(PlatformType || (PlatformType = {}));
export var Themes;
(function (Themes) {
    Themes["default"] = "default";
    Themes["dark"] = "dark";
    Themes["highContrast"] = "contrast";
})(Themes || (Themes = {}));
/**
 * User setting changes that can be subscribed to,
 */
export var UserSettingTypes;
(function (UserSettingTypes) {
    /**
     * Use this key to subscribe to changes in user's file open preference
     */
    UserSettingTypes["fileOpenPreference"] = "fileOpenPreference";
    /**
     * Use this key to subscribe to theme changes
     */
    UserSettingTypes["theme"] = "theme";
})(UserSettingTypes || (UserSettingTypes = {}));
/**
 * Enum for host client types
 */
export var HostClientType;
(function (HostClientType) {
    HostClientType["web"] = "web";
    HostClientType["desktop"] = "desktop";
})(HostClientType || (HostClientType = {}));
/**
 * Enum for frame contexts to determine scope of different sdk apis
 */
export var FrameContexts;
(function (FrameContexts) {
    FrameContexts["settings"] = "settings";
    FrameContexts["content"] = "content";
    FrameContexts["authentication"] = "authentication";
    FrameContexts["remove"] = "remove";
    FrameContexts["task"] = "task";
    FrameContexts["sidePanel"] = "sidePanel";
    FrameContexts["meetingStage"] = "meetingStage";
})(FrameContexts || (FrameContexts = {}));
//# sourceMappingURL=messages.interface.js.map